import { render } from "./customizeDefaultSetup.vue?vue&type=template&id=32395d5c&scoped=true"
import script from "./customizeDefaultSetup.vue?vue&type=script&lang=js"
export * from "./customizeDefaultSetup.vue?vue&type=script&lang=js"

import "./customizeDefaultSetup.vue?vue&type=style&index=0&id=32395d5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32395d5c"]])

export default __exports__